import React from 'react';
import { BlockContainer } from './styled';

interface IProps {
  weeklyHours?: string;
  credits?: string;
  numberOfTimes?: string;
  section?: string;
}
const SecondBlock = (props: IProps) => {
  const { weeklyHours, credits, numberOfTimes, section } = props;

  return (
    <BlockContainer>
      <div className="secondBlock">
        <p>
          Horas semanales:{' '}
          {weeklyHours ? (
            <span>{Number(weeklyHours).toFixed(1)}</span>
          ) : (
            <span>--</span>
          )}
        </p>
        <p>Créditos: {credits ? <span>{credits}</span> : <span>--</span>}</p>
        <p>
          Nro vez:{' '}
          {numberOfTimes ? <span>{numberOfTimes}</span> : <span>--</span>}
        </p>
        <p>Sección: {section ? <span>{section}</span> : <span>--</span>}</p>
      </div>
    </BlockContainer>
  );
};

export default SecondBlock;
